import { writable } from "svelte/store";
export const toastComponent = writable({ label: '', hidden: true });
export function showToast(label) {
    if (!label) {
        return;
    }
    toastComponent.set({ label, hidden: false });
    setTimeout(() => {
        removeToast();
    }, 4000);
}
export function removeToast() {
    toastComponent.update((toast) => (Object.assign(Object.assign({}, toast), { hidden: true })));
    setTimeout(() => {
        toastComponent.set({ label: '', hidden: true });
    }, 300);
}
